<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal ">
          <div class="modal-head">{{ title }}</div>
          <div class="modal-con">
            <div class="modal-txt">
              <pre v-html="contents"></pre>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn border-gray" :class="leftInnerClass" @click="cancel">
                {{ cancelText }}
              </button>
              <button class="btn" :class="rightInnerClass" @click="done">
                {{ doneText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, toRefs } from 'vue';

const props = defineProps(['data']);
const { title, contents, doneText, cancelText, rightInnerClass, leftInnerClass } = toRefs(props.data);
const { doneCallback, cancelCallback } = props.data;
const emits = defineEmits(['close']);

const on = ref(false);
const cancel = () => {
  if (cancelCallback) cancelCallback();
  close();
};
const done = () => {
  if (doneCallback) doneCallback();
  close();
};

const close = () => {
  emits('close');
};
</script>

<style scoped></style>
